// @flow
import SV from 'server-vars';
import tracking from 'dibs-tracking';

function getTrackingUrl({ isVpv = false }: { isVpv?: ?boolean }) {
    if (isVpv) {
        return `${window.location.protocol}//${window.location.host}/vpv${window.location.pathname}`;
    }

    return window.location.href;
}

type pageViewProps = {
    url?: string,
    pageType?: string,
    pageSubType?: string,
    isVpv?: boolean,
};

export const trackPageView = (trackObj?: pageViewProps = {}): void => {
    const initialTrackingValues = SV.get('tracking.initialDataLayerInfo') || null;
    const pageView = {
        url: getTrackingUrl(trackObj),
        additional: {},
    };
    let hasAdditionalTrackingValues = false;
    if (trackObj) {
        if (trackObj.url) {
            pageView.url = trackObj.url;
        }
        if (trackObj.pageType && trackObj.pageSubType) {
            pageView.additional.pageType = trackObj.pageType;
            pageView.additional.pageSubType = trackObj.pageSubType;
            hasAdditionalTrackingValues = true;
        } else {
            hasAdditionalTrackingValues = false;
        }
    }
    if (!hasAdditionalTrackingValues && initialTrackingValues) {
        const additional = {};
        if (initialTrackingValues.pageType) {
            additional.pageType = initialTrackingValues.pageType;
        }
        if (initialTrackingValues.pageSubType) {
            additional.pageSubType = initialTrackingValues.pageSubType;
        }
        if (Object.keys(additional).length) {
            pageView.additional = additional;
        }
    }
    tracking.trackPageview(pageView);
};

type trackEventProps = {
    category: string,
    action: string,
    label?: string,
};

export const trackEvent = ({ category, action, label }: trackEventProps) => {
    let trackObj = { category, action };
    if (label) {
        trackObj = {
            ...trackObj,
            label,
        };
    }
    tracking.trackEvent(trackObj);
};

export type trackEcomEventProps = {
    id: string,
    position: number,
    price: number | string,
    brand: string,
    category: string,
    categoryCode: string,
    dimension76: string,
    dimension83: string,
    name: string,
    list: string,
};

type trackEcomArgs = {
    type: 'productImpression' | 'productClick',
    products: Array<trackEcomEventProps> | trackEcomEventProps,
    actionFieldList?: string,
};

export const trackEcomEvent = ({ type, products, actionFieldList }: trackEcomArgs) => {
    const trackObj = {
        products: Array.isArray(products) ? products : [products],
        type,
        actionField: {},
    };
    if (actionFieldList) {
        trackObj.actionField = {
            list: actionFieldList,
        };
    }
    tracking.trackEcommerce(trackObj);
};
